import React from 'react';
import { Link } from 'react-router-dom';
import PageLayout from '../components/common/PageLayout';


const Courses = () => (
  <PageLayout>
    <section className="page-hero">
      <h1>Courses</h1>
      <p>Structured learning paths in tech, data, and business—with projects and certificates.</p>
      <p style={{ marginTop: '1rem' }}>
        <Link to="/offerings" className="page-hero-cta">Browse all offerings</Link>
      </p>
    </section>
    <section className="page-section">
      <p>From fundamentals to advanced specializations, our courses are designed for real-world impact.</p>
      <div className="page-section-grid">
        <div className="page-card">
          <h3>Tech & development</h3>
          <p>Web, cloud, and software development tracks.</p>
          <Link to="/offerings">View offerings</Link>
        </div>
        <div className="page-card">
          <h3>Data & AI</h3>
          <p>Data science, analytics, and AI/ML programs.</p>
          <Link to="/offerings">View offerings</Link>
        </div>
        <div className="page-card">
          <h3>Business & soft skills</h3>
          <p>Leadership, communication, and project management.</p>
          <Link to="/offerings">View offerings</Link>
        </div>
      </div>
    </section>
    <section className="page-section">
      <h2>Related</h2>
      <p>Choose a <Link to="/tracks/corporates">For Corporates</Link>, <Link to="/tracks/individuals">For Individuals</Link>, or <Link to="/tracks/colleges">For Colleges</Link> track, or explore <Link to="/resources">Resources</Link> and <Link to="/contact">Contact Us</Link>.</p>
    </section>
  </PageLayout>
);

export default Courses;
